import { selectAllCompanyUsersById } from "app/containers/Global/slice";
import Button from "app/storybookComponents/Button";
import { useAppSelector } from "utils/redux/hooks";
import AvatarCircle from "../AvatarCircle";

interface Props {
  userAccountId: number;
  onRemoveClick: () => void;
}
const SelectedUserBox = ({ userAccountId, onRemoveClick }: Readonly<Props>) => {
  const userById = useAppSelector(selectAllCompanyUsersById);
  const user = userById[userAccountId];

  return (
    <div className="flex items-center gap-2 justify-between rounded-lg p-4 shadow-sm border border-gray-200 bg-white">
      <div className="flex items-center gap-2">
        <AvatarCircle userAccountId={userAccountId} size="small" />
        <p>
          <b>
            {user?.firstName} {user?.lastName}
          </b>{" "}
          - {user?.jobTitle || "No job title"}
        </p>
      </div>
      <Button
        onClick={() => {
          onRemoveClick();
        }}
        variant="secondary-gray"
      >
        Remove
      </Button>
    </div>
  );
};

export default SelectedUserBox;
